import { fetchFromOldApi } from '~/services/Http';

import { LegacyProposalAPI } from '../../data';

type DeleteProposalProps = {
  employeeId: number;
  employmentId: number;
  proposalId: string;
};

export const deleteLegacyProposal = async (
  proposalAPI: LegacyProposalAPI,
  props: DeleteProposalProps,
) => {
  const { employeeId, employmentId, proposalId } = props;
  const url = `/json/employee/${employeeId}/employment/${employmentId}/${proposalAPI}/${proposalId}`;
  await fetchFromOldApi(url, {
    method: 'DELETE',
  }).then((r) => r.json());
};
